"use strict";
var _a;
exports.__esModule = true;
exports.OPERATOR_MAP = void 0;
var types_1 = require("../types");
var utils_1 = require("./utils");
exports.OPERATOR_MAP = (_a = {},
    _a[types_1.Operators.AND] = utils_1.andUtil,
    _a[types_1.Operators.OR] = utils_1.orUtil,
    _a[types_1.Operators.XOR] = utils_1.xorUtil,
    _a);
